// src/constants/products.js
const CHARWIDTHS = {
  A: 1.1,
  B: 1.1,
  C: 1.2,
  D: 1.2,
  E: 1.1,
  F: 1.0,
  G: 1.2,
  H: 1.2,
  I: 0.6,
  J: 1.0,
  K: 1.1,
  L: 1.0,
  M: 1.4,
  N: 1.2,
  O: 1.3,
  P: 1.0,
  Q: 1.3,
  R: 1.1,
  S: 1.1,
  T: 1.1,
  U: 1.1,
  V: 1.1,
  W: 1.5,
  X: 1.1,
  Y: 1.1,
  Z: 1.1,
  a: 0.9,
  b: 1.0,
  c: 0.9,
  d: 1.0,
  e: 1.0,
  f: 0.6,
  g: 1.0,
  h: 0.9,
  i: 0.4,
  j: 0.6,
  k: 0.9,
  l: 0.5,
  m: 1.4,
  n: 0.9,
  o: 1.0,
  p: 1.0,
  q: 1.0,
  r: 0.7,
  s: 0.9,
  t: 0.6,
  u: 1.0,
  v: 0.8,
  w: 1.3,
  x: 0.9,
  y: 0.9,
  z: 0.9,
  0: 1.1,
  1: 0.7,
  2: 1.0,
  3: 1.1,
  4: 1.1,
  5: 1.0,
  6: 1.1,
  7: 1.0,
  8: 1.1,
  9: 1.1,
  "&": 1.2,
  ",": 0.5,
  ".": 0.5,
  "-": 0.7,
};

const VL02SIZES = [
  { name: "1 inch", code: "01", height: 1, charPrice: 1.55 },
  { name: "2 inch", code: "02", height: 2, charPrice: 1.55 },
  { name: "3 inch", code: "03", height: 3, charPrice: 1.89 },
  { name: "4 inch", code: "04", height: 4, charPrice: 2.0 },
  { name: "5 inch", code: "05", height: 5, charPrice: 2.65 },
  { name: "6 inch", code: "06", height: 6, charPrice: 3.0 },
  { name: "7 inch", code: "07", height: 7, charPrice: 3.42 },
  { name: "8 inch", code: "08", height: 8, charPrice: 3.9 },
  { name: "9 inch", code: "09", height: 9, charPrice: 4.72 },
  { name: "10 inch", code: "10", height: 10, charPrice: 5.35 },
  { name: "11 inch", code: "11", height: 11, charPrice: 6.25 },
  { name: "12 inch", code: "12", height: 12, charPrice: 7.15 },
];

const VL03SIZES = [
  { name: "1 inch", code: "01", height: 1, charPrice: 2.45 },
  { name: "2 inch", code: "02", height: 2, charPrice: 2.45 },
  { name: "3 inch", code: "03", height: 3, charPrice: 3.1 },
  { name: "4 inch", code: "04", height: 4, charPrice: 4.22 },
  { name: "5 inch", code: "05", height: 5, charPrice: 5.46 },
  { name: "6 inch", code: "06", height: 6, charPrice: 6.99 },
  { name: "7 inch", code: "07", height: 7, charPrice: 8.72 },
  { name: "8 inch", code: "08", height: 8, charPrice: 10.92 },
  { name: "9 inch", code: "09", height: 9, charPrice: 13.09 },
  { name: "10 inch", code: "10", height: 10, charPrice: 15.82 },
  { name: "11 inch", code: "11", height: 11, charPrice: 18.47 },
  { name: "12 inch", code: "12", height: 12, charPrice: 20.17 },
];

const BL10SIZES = [
  { name: "6 inches", code: "06", pixels: 432, height: 6, basePrice: 22.75 },
  { name: "8 inches", code: "08", pixels: 576, height: 8, basePrice: 29.75 },
  { name: "9 inches", code: "09", pixels: 648, height: 8, basePrice: 34.1 },
  {
    name: "10 inches",
    code: "10",
    pixels: 720,
    height: 10,
    basePrice: 37.5,
  },
  {
    name: "12 inches",
    code: "12",
    pixels: 864,
    height: 12,
    basePrice: 47.25,
  },
  {
    name: "15 inches",
    code: "15",
    pixels: 1080,
    height: 15,
    basePrice: 64.75,
  },
  {
    name: "18 inches",
    code: "18",
    pixels: 1296,
    height: 18,
    basePrice: 84.0,
  },
  {
    name: "24 inches",
    code: "24",
    pixels: 1728,
    height: 24,
    basePrice: 140.0,
  },
  {
    name: "30 inches",
    code: "30",
    pixels: 2160,
    height: 30,
    basePrice: 201.4,
  },
  {
    name: "36 inches",
    code: "36",
    pixels: 2592,
    height: 36,
    basePrice: 295.0,
  },
];

const BL20SIZES = [
  { name: "4 inch", code: "04", pixels: 288, height: 4, basePrice: 41 },
  { name: "5 inch", code: "05", pixels: 360, height: 5, basePrice: 50 },
  { name: "6 inch", code: "06", pixels: 432, height: 6, basePrice: 54 },
  { name: "7 inch", code: "07", pixels: 504, height: 7, basePrice: 61 },
  { name: "8 inch", code: "08", pixels: 576, height: 8, basePrice: 70 },
  { name: "9 inch", code: "09", pixels: 648, height: 9, basePrice: 86 },
  {
    name: "10 inch",
    code: "10",
    pixels: 720,
    height: 10,
    basePrice: 90,
  },
  {
    name: "11 inch",
    code: "11",
    pixels: 792,
    height: 10,
    basePrice: 100,
  },
  {
    name: "12 inch",
    code: "12",
    pixels: 864,
    height: 12,
    basePrice: 108,
  },
  {
    name: "13 inch",
    code: "13",
    pixels: 936,
    height: 13,
    basePrice: 117,
  },
  {
    name: "14 inch",
    code: "14",
    pixels: 1008,
    height: 14,
    basePrice: 148,
  },
  {
    name: "15 inch",
    code: "15",
    pixels: 1080,
    height: 15,
    basePrice: 169,
  },
  {
    name: "16 inch",
    code: "16",
    pixels: 1152,
    height: 16,
    basePrice: 181,
  },
  {
    name: "17 inch",
    code: "17",
    pixels: 1224,
    height: 17,
    basePrice: 216,
  },
  {
    name: "18 inch",
    code: "18",
    pixels: 1296,
    height: 18,
    basePrice: 223,
  },
  {
    name: "19 inch",
    code: "19",
    pixels: 1368,
    height: 19,
    basePrice: 240,
  },
  {
    name: "20 inch",
    code: "20",
    pixels: 1440,
    height: 20,
    basePrice: 265,
  },
  {
    name: "21 inch",
    code: "21",
    pixels: 1512,
    height: 21,
    basePrice: 293,
  },
  {
    name: "22 inch",
    code: "22",
    pixels: 1584,
    height: 22,
    basePrice: 314,
  },
  {
    name: "23 inch",
    code: "23",
    pixels: 1656,
    height: 23,
    basePrice: 329,
  },
  {
    name: "24 inch",
    code: "24",
    pixels: 1728,
    height: 24,
    basePrice: 356,
  },
];

const BL22SIZES = [
  { name: "4 inch", code: "04", pixels: 288, height: 4, basePrice: 81 },
  { name: "5 inch", code: "05", pixels: 360, height: 5, basePrice: 108 },
  { name: "6 inch", code: "06", pixels: 432, height: 6, basePrice: 113 },
  { name: "7 inch", code: "07", pixels: 504, height: 7, basePrice: 134 },
  { name: "8 inch", code: "08", pixels: 576, height: 8, basePrice: 151 },
  { name: "9 inch", code: "09", pixels: 648, height: 9, basePrice: 171 },
  {
    name: "10 inch",
    code: "10",
    pixels: 720,
    height: 10,
    basePrice: 182,
  },
  {
    name: "11 inch",
    code: "11",
    pixels: 792,
    height: 10,
    basePrice: 205,
  },
  {
    name: "12 inch",
    code: "12",
    pixels: 864,
    height: 12,
    basePrice: 254,
  },
  {
    name: "13 inch",
    code: "13",
    pixels: 936,
    height: 13,
    basePrice: 299,
  },
  {
    name: "14 inch",
    code: "14",
    pixels: 1008,
    height: 14,
    basePrice: 327,
  },
  {
    name: "15 inch",
    code: "15",
    pixels: 1080,
    height: 15,
    basePrice: 383,
  },
  {
    name: "16 inch",
    code: "16",
    pixels: 1152,
    height: 16,
    basePrice: 428,
  },
  {
    name: "17 inch",
    code: "17",
    pixels: 1224,
    height: 17,
    basePrice: 486,
  },
  {
    name: "18 inch",
    code: "18",
    pixels: 1296,
    height: 18,
    basePrice: 551,
  },
  {
    name: "19 inch",
    code: "19",
    pixels: 1368,
    height: 19,
    basePrice: 616,
  },
  {
    name: "20 inch",
    code: "20",
    pixels: 1440,
    height: 20,
    basePrice: 697,
  },
  {
    name: "21 inch",
    code: "21",
    pixels: 1512,
    height: 21,
    basePrice: 786,
  },
  {
    name: "22 inch",
    code: "22",
    pixels: 1584,
    height: 22,
    basePrice: 839,
  },
  {
    name: "23 inch",
    code: "23",
    pixels: 1656,
    height: 23,
    basePrice: 868,
  },
  {
    name: "24 inch",
    code: "24",
    pixels: 1728,
    height: 24,
    basePrice: 906,
  },
];

const BL310SIZES = [
  { name: "2 inch", code: "02", pixels: 144, height: 2, basePrice: 22.0 },
  { name: "3 inch", code: "03", pixels: 216, height: 3, basePrice: 28.0 },
  { name: "4 inch", code: "04", pixels: 288, height: 4, basePrice: 37.0 },
  { name: "5 inch", code: "05", pixels: 360, height: 5, basePrice: 43.0 },
  { name: "6 inch", code: "06", pixels: 432, height: 6, basePrice: 53.0 },
  { name: "7 inch", code: "07", pixels: 504, height: 7, basePrice: 64.0 },
  { name: "8 inch", code: "08", pixels: 576, height: 8, basePrice: 67.0 },
  { name: "9 inch", code: "09", pixels: 648, height: 9, basePrice: 71.0 },
  { name: "10 inch", code: "10", pixels: 720, height: 10, basePrice: 77.0 },
  { name: "11 inch", code: "11", pixels: 792, height: 11, basePrice: 85.0 },
  { name: "12 inch", code: "12", pixels: 864, height: 12, basePrice: 90.0 },
  { name: "13 inch", code: "13", pixels: 936, height: 13, basePrice: 98.0 },
  { name: "14 inch", code: "14", pixels: 1008, height: 14, basePrice: 107.0 },
  { name: "15 inch", code: "15", pixels: 1080, height: 15, basePrice: 118.0 },
  { name: "16 inch", code: "16", pixels: 1152, height: 16, basePrice: 125.0 },
  { name: "17 inch", code: "17", pixels: 1224, height: 17, basePrice: 137.0 },
  { name: "18 inch", code: "18", pixels: 1296, height: 18, basePrice: 141.0 },
  { name: "19 inch", code: "19", pixels: 1368, height: 19, basePrice: 157.0 },
  { name: "20 inch", code: "20", pixels: 1440, height: 20, basePrice: 167.0 },
  { name: "21 inch", code: "21", pixels: 1512, height: 21, basePrice: 194.0 },
  { name: "22 inch", code: "22", pixels: 1884, height: 22, basePrice: 211.0 },
  { name: "23 inch", code: "23", pixels: 1656, height: 23, basePrice: 230.0 },
  { name: "24 inch", code: "24", pixels: 1728, height: 24, basePrice: 281.0 },
];

const BL320SIZES = [
  { name: "2 inch", code: "02", pixels: 144, height: 2, basePrice: 47.0 },
  { name: "3 inch", code: "03", pixels: 216, height: 3, basePrice: 54.0 },
  { name: "4 inch", code: "04", pixels: 288, height: 4, basePrice: 64.0 },
  { name: "5 inch", code: "05", pixels: 360, height: 5, basePrice: 81.0 },
  { name: "6 inch", code: "06", pixels: 432, height: 6, basePrice: 95.0 },
  { name: "7 inch", code: "07", pixels: 504, height: 7, basePrice: 114.0 },
  { name: "8 inch", code: "08", pixels: 576, height: 8, basePrice: 134.0 },
  { name: "9 inch", code: "09", pixels: 648, height: 9, basePrice: 156.0 },
  { name: "10 inch", code: "10", pixels: 720, height: 10, basePrice: 176.0 },
  { name: "11 inch", code: "11", pixels: 792, height: 11, basePrice: 203.0 },
  { name: "12 inch", code: "12", pixels: 864, height: 12, basePrice: 231.0 },
  { name: "13 inch", code: "13", pixels: 936, height: 13, basePrice: 262.0 },
  { name: "14 inch", code: "14", pixels: 1008, height: 14, basePrice: 295.0 },
  { name: "15 inch", code: "15", pixels: 1080, height: 15, basePrice: 331.0 },
  { name: "16 inch", code: "16", pixels: 1152, height: 16, basePrice: 368.0 },
  { name: "17 inch", code: "17", pixels: 1224, height: 17, basePrice: 407.0 },
  { name: "18 inch", code: "18", pixels: 1296, height: 18, basePrice: 448.0 },
  { name: "19 inch", code: "19", pixels: 1368, height: 19, basePrice: 489.0 },
  { name: "20 inch", code: "20", pixels: 1440, height: 20, basePrice: 546.0 },
  { name: "21 inch", code: "21", pixels: 1512, height: 21, basePrice: 596.0 },
  { name: "22 inch", code: "22", pixels: 1884, height: 22, basePrice: 651.0 },
  { name: "23 inch", code: "23", pixels: 1656, height: 23, basePrice: 708.0 },
  { name: "24 inch", code: "24", pixels: 1728, height: 24, basePrice: 765.0 },
];

const BL330SIZES = [
  { name: "2 inch", code: "02", pixels: 144, height: 2, basePrice: 47.0 },
  { name: "3 inch", code: "03", pixels: 216, height: 3, basePrice: 54.0 },
  { name: "4 inch", code: "04", pixels: 288, height: 4, basePrice: 64.0 },
  { name: "5 inch", code: "05", pixels: 360, height: 5, basePrice: 81.0 },
  { name: "6 inch", code: "06", pixels: 432, height: 6, basePrice: 95.0 },
  { name: "7 inch", code: "07", pixels: 504, height: 7, basePrice: 114.0 },
  { name: "8 inch", code: "08", pixels: 576, height: 8, basePrice: 134.0 },
  { name: "9 inch", code: "09", pixels: 648, height: 9, basePrice: 156.0 },
  { name: "10 inch", code: "10", pixels: 720, height: 10, basePrice: 176.0 },
  { name: "11 inch", code: "11", pixels: 792, height: 11, basePrice: 203.0 },
  { name: "12 inch", code: "12", pixels: 864, height: 12, basePrice: 231.0 },
  { name: "13 inch", code: "13", pixels: 936, height: 13, basePrice: 262.0 },
  { name: "14 inch", code: "14", pixels: 1008, height: 14, basePrice: 295.0 },
  { name: "15 inch", code: "15", pixels: 1080, height: 15, basePrice: 331.0 },
  { name: "16 inch", code: "16", pixels: 1152, height: 16, basePrice: 368.0 },
  { name: "17 inch", code: "17", pixels: 1224, height: 17, basePrice: 407.0 },
  { name: "18 inch", code: "18", pixels: 1296, height: 18, basePrice: 448.0 },
  { name: "19 inch", code: "19", pixels: 1368, height: 19, basePrice: 489.0 },
  { name: "20 inch", code: "20", pixels: 1440, height: 20, basePrice: 546.0 },
  { name: "21 inch", code: "21", pixels: 1512, height: 21, basePrice: 596.0 },
  { name: "22 inch", code: "22", pixels: 1884, height: 22, basePrice: 651.0 },
  { name: "23 inch", code: "23", pixels: 1656, height: 23, basePrice: 708.0 },
  { name: "24 inch", code: "24", pixels: 1728, height: 24, basePrice: 765.0 },
];

const BL401SIZES = [
  { name: "2 inch", code: "02", pixels: 144, height: 2, basePrice: 6.2 },
  { name: "3 inch", code: "03", pixels: 216, height: 3, basePrice: 9.3 },
  { name: "4 inch", code: "04", pixels: 288, height: 4, basePrice: 10.3 },
  { name: "5 inch", code: "05", pixels: 360, height: 5, basePrice: 11.3 },
  { name: "6 inch", code: "06", pixels: 432, height: 6, basePrice: 12.4 },
  { name: "7 inch", code: "07", pixels: 504, height: 7, basePrice: 14.4 },
  { name: "8 inch", code: "08", pixels: 576, height: 8, basePrice: 16.5 },
  { name: "9 inch", code: "09", pixels: 648, height: 9, basePrice: 19.6 },
  { name: "10 inch", code: "10", pixels: 720, height: 10, basePrice: 23.7 },
  { name: "11 inch", code: "11", pixels: 792, height: 11, basePrice: 25.75 },
  { name: "12 inch", code: "12", pixels: 864, height: 12, basePrice: 29.9 },
  { name: "13 inch", code: "13", pixels: 936, height: 13, basePrice: 33 },
  { name: "14 inch", code: "14", pixels: 1008, height: 14, basePrice: 37 },
  { name: "15 inch", code: "15", pixels: 1080, height: 15, basePrice: 41.2 },
  { name: "16 inch", code: "16", pixels: 1152, height: 16, basePrice: 44.3 },
  { name: "17 inch", code: "17", pixels: 1224, height: 17, basePrice: 48.4 },
  { name: "18 inch", code: "18", pixels: 1296, height: 18, basePrice: 52.5 },
  { name: "19 inch", code: "19", pixels: 1368, height: 19, basePrice: 56.65 },
  { name: "20 inch", code: "20", pixels: 1440, height: 20, basePrice: 62.8 },
  { name: "21 inch", code: "21", pixels: 1512, height: 21, basePrice: 69 },
  { name: "22 inch", code: "22", pixels: 1884, height: 22, basePrice: 75.2 },
  { name: "23 inch", code: "23", pixels: 1656, height: 23, basePrice: 81.4 },
  { name: "24 inch", code: "24", pixels: 1728, height: 24, basePrice: 87.5 },
];

const BL402SIZES = [
  { name: "3 inch", code: "03", pixels: 216, height: 3, basePrice: 7.9 },
  { name: "4 inch", code: "04", pixels: 288, height: 4, basePrice: 9.6 },
  { name: "5 inch", code: "05", pixels: 360, height: 5, basePrice: 12.3 },
  { name: "6 inch", code: "06", pixels: 432, height: 6, basePrice: 14.9 },
  { name: "7 inch", code: "07", pixels: 504, height: 7, basePrice: 19.3 },
  { name: "8 inch", code: "08", pixels: 576, height: 8, basePrice: 23.6 },
  { name: "9 inch", code: "09", pixels: 648, height: 9, basePrice: 28.9 },
  { name: "10 inch", code: "10", pixels: 720, height: 10, basePrice: 35.0 },
  { name: "11 inch", code: "11", pixels: 792, height: 11, basePrice: 41.0 },
  { name: "12 inch", code: "12", pixels: 864, height: 12, basePrice: 48.2 },
  { name: "13 inch", code: "13", pixels: 936, height: 13, basePrice: 55.2 },
  { name: "14 inch", code: "14", pixels: 1008, height: 14, basePrice: 63.0 },
  { name: "15 inch", code: "15", pixels: 1080, height: 15, basePrice: 70.9 },
  { name: "16 inch", code: "16", pixels: 1152, height: 16, basePrice: 79.7 },
  { name: "17 inch", code: "17", pixels: 1224, height: 17, basePrice: 88.4 },
  { name: "18 inch", code: "18", pixels: 1296, height: 18, basePrice: 98.1 },
  { name: "19 inch", code: "19", pixels: 1368, height: 19, basePrice: 107.1 },
  { name: "20 inch", code: "20", pixels: 1440, height: 20, basePrice: 119.9 },
  { name: "21 inch", code: "21", pixels: 1512, height: 21, basePrice: 132.2 },
  { name: "22 inch", code: "22", pixels: 1884, height: 22, basePrice: 144.5 },
  { name: "23 inch", code: "23", pixels: 1656, height: 23, basePrice: 156.7 },
  { name: "24 inch", code: "24", pixels: 1728, height: 24, basePrice: 169.8 },
];

const PFL10SIZES = [
  { name: "4 inch", code: "04", pixels: 288, height: 4, basePrice: 23.0 },
  { name: "5 inch", code: "05", pixels: 360, height: 5, basePrice: 25.5 },
  { name: "6 inch", code: "06", pixels: 432, height: 6, basePrice: 31.25 },
  { name: "7 inch", code: "07", pixels: 504, height: 7, basePrice: 37.85 },
  { name: "8 inch", code: "08", pixels: 576, height: 8, basePrice: 45.25 },
  { name: "9 inch", code: "09", pixels: 648, height: 9, basePrice: 53.5 },
  { name: "10 inch", code: "10", pixels: 720, height: 10, basePrice: 63.5 },
  { name: "11 inch", code: "11", pixels: 792, height: 11, basePrice: 72.5 },
  { name: "12 inch", code: "12", pixels: 864, height: 12, basePrice: 84.0 },
  { name: "13 inch", code: "13", pixels: 936, height: 13, basePrice: 96.5 },
  { name: "14 inch", code: "14", pixels: 1008, height: 14, basePrice: 110.0 },
  { name: "15 inch", code: "15", pixels: 1080, height: 15, basePrice: 123.5 },
  { name: "16 inch", code: "16", pixels: 1152, height: 16, basePrice: 137.5 },
  { name: "17 inch", code: "17", pixels: 1224, height: 17, basePrice: 153.25 },
  { name: "18 inch", code: "18", pixels: 1296, height: 18, basePrice: 169.0 },
  { name: "19 inch", code: "19", pixels: 1368, height: 19, basePrice: 186.0 },
  { name: "20 inch", code: "20", pixels: 1440, height: 20, basePrice: 205.0 },
  { name: "21 inch", code: "21", pixels: 1512, height: 21, basePrice: 225.0 },
  { name: "22 inch", code: "22", pixels: 1884, height: 22, basePrice: 246.0 },
  { name: "23 inch", code: "23", pixels: 1656, height: 23, basePrice: 267.5 },
  { name: "24 inch", code: "24", pixels: 1728, height: 24, basePrice: 290.0 },
];

const ML00SIZES = [
  { name: "2 inch", code: "02", pixels: 144, height: 2, basePrice: 18.5 },
  { name: "3 inch", code: "03", pixels: 216, height: 3, basePrice: 21.6 },
  { name: "4 inch", code: "04", pixels: 288, height: 4, basePrice: 23.75 },
  { name: "6 inch", code: "06", pixels: 432, height: 6, basePrice: 27.8 },
  { name: "8 inch", code: "08", pixels: 576, height: 8, basePrice: 37 },
  { name: "10 inch", code: "10", pixels: 720, height: 10, basePrice: 51.5 },
  { name: "12 inch", code: "12", pixels: 864, height: 12, basePrice: 59.75 },
];

const BL70SIZES = [
  { name: "3 inch", code: "03", pixels: 216, height: 3, basePrice: 8.25 },
  { name: "4 inch", code: "04", pixels: 288, height: 4, basePrice: 9.25 },
  { name: "5 inch", code: "05", pixels: 360, height: 5, basePrice: 10.3 },
  { name: "6 inch", code: "06", pixels: 432, height: 6, basePrice: 13.4 },
  { name: "7 inch", code: "07", pixels: 504, height: 7, basePrice: 13.4 },
  { name: "8 inch", code: "08", pixels: 576, height: 8, basePrice: 16.5 },
  { name: "9 inch", code: "09", pixels: 648, height: 9, basePrice: 18.5 },
  { name: "10 inch", code: "10", pixels: 720, height: 10, basePrice: 22.6 },
  { name: "11 inch", code: "11", pixels: 792, height: 11, basePrice: 24.75 },
  { name: "12 inch", code: "12", pixels: 864, height: 12, basePrice: 27.75 },
  { name: "13 inch", code: "13", pixels: 936, height: 13, basePrice: 31.95 },
  { name: "14 inch", code: "14", pixels: 1008, height: 14, basePrice: 36.0 },
  { name: "15 inch", code: "15", pixels: 1080, height: 15, basePrice: 40.0 },
  { name: "16 inch", code: "16", pixels: 1152, height: 16, basePrice: 43.25 },
  { name: "17 inch", code: "17", pixels: 1224, height: 17, basePrice: 47.4 },
  { name: "18 inch", code: "18", pixels: 1296, height: 18, basePrice: 51.5 },
  { name: "19 inch", code: "19", pixels: 1368, height: 19, basePrice: 55.5 },
  { name: "20 inch", code: "20", pixels: 1440, height: 20, basePrice: 59.75 },
  { name: "21 inch", code: "21", pixels: 1512, height: 21, basePrice: 67.75 },
  { name: "22 inch", code: "22", pixels: 1884, height: 22, basePrice: 74.0 },
  { name: "23 inch", code: "23", pixels: 1656, height: 23, basePrice: 80.0 },
  { name: "24 inch", code: "24", pixels: 1728, height: 24, basePrice: 85.5 },
];

export const PRODUCTS = [
  {
    code: "BL1000",
    name: "Plastic Formed Sign Letters",
    header: "PLASTIC SIGN LETTERS FOR OUTDOOR",
    headerText:
      "Plastic building sign letters used for outdoor signage of business names or address numbers are available in 7 fonts and 47 colors. Use our sign design online tool to custom design your plastic sign letters, preview font styles and calculate sign dimensions. Plastic sign letters are easy to install and include mounting hardware and a lifetime guarantee.",
    description:
      "Plastic building sign letters are a three dimensional formed letter used for exterior sign identification. Outdoor plastic sign letters are made from a special, durable CAB plastic and are guaranteed for life from fading or breakage. The plastic sign letters are available in 47 weather resistant colors. Each individually molded plastic building sign letter comes complete with mounting hardware and installs in minutes. Plastic building sign letters can be produced quickly and more economically than flat cut out acrylic letters. Formed plastic letters also have added depth to stand off from a building wall than flat acrylic letters. Plastic building sign letters are available in seven styles and standard sizes whereas flat cut acrylic has unlimited options. Plastic building sign letters cannot be backlit or used as a channel letter.",
    breadcrumbs: [
      {
        name: "Building Sign Letters",
        href: "https://www.alphabetsigns.com/signs/building-sign-letters.html",
      },
      {
        name: "Formed Plastic",
        href: "https://www.alphabetsigns.com/signs/plastic-building-sign-letters.html",
      },
    ],
    defaultSize: "06",
    defaultColor: "Black_0103",
    defaultFillHex: "#000000",
    sizes: BL10SIZES,
    priceFactor: 1.0,
    scaleFactor: 72,
    pdf: ["formed_plastic.pdf"],
    product_attributes: {
      phrase: { type: "text", required: true },
      color: {
        type: "select",
        required: true,
        code: "Paint_Color",
        template_code: "",
        options: [],
      },
      font: {
        type: "select",
        required: true,
        code: "Font",
        template_code: "",
        options: [],
      },
      size: { type: "select", required: true, options: BL10SIZES },
      hardware: {
        type: "select",
        required: true,
        code: "Mounting_Hardware",
        template_code: "Hardware",
        options: [],
      },
    },
  },
  {
    code: "BL2000",
    name: "Cast Metal Sign Letters & Numbers",
    header: "DESIGN YOUR CAST METAL LETTERS",
    headerText:
      "Cast metal letters are precision cast in aluminum using up to twenty distinct manufacturing steps. Use our sign design tool to view your cast metal letters that provide strength and permanence to your image. Eight metal finishes give you the choice of dazzling shine, brilliant color, or natural and antiquated metal. Custom design your cast metal letters and numbers, preview font styles and calculate sign dimensions.",
    description:
      "Lifetime guarantee! Each metal letter is precision cast in aluminum using up to twenty distinct manufacturing steps. The metal provides strength and permanence to your image. Eight metal finishes give you the choice of dazzling shine, brilliant color, or natural and antiquated metal. Combine these finishes with an extensive selection of letter styles to design signs that reflect your individual image. The cast aluminum sign letters use virgin aluminum ingots Alloy 356 that are melted down in an all-electric, pollution free furnace. Aluminum Alloy 356 is a superior metal for outdoor signage because of its strength, hardness and corrosion resistance against weather extremes particularly in marine areas. This aluminum alloy has a tensile strength of 38,000 psi! The mold also has added depth to give your character real dimension. Once your letter has been cast by skilled craftsmen, it is shot blasted, degated and belt sanded in preparation of finishing. The cast metal characters are turned over, drilled and tapped at the appropriate stud diameter for its stud mounting hardware used during your installation. In the finishing process, the letter is bead-blasted to make it precise and smooth then stroke sanded to give it a natural satin finish. The letters are set up on a rack where it is coated with a two-part hardened acrylic polyurethane clear coat, then sent to an oven for baking. Your letters are then laid out for careful quality inspection then seal-tight packaged so your letters arrive mistake-free. The cast aluminum letters can be anodizing in the colors of clear, gold, medium bronze, dark bronze or black. The anodized aluminum letter uses virgin ingots Alloy 514. Anodizing is an electro-chemical process which embeds the colored dye into the microscopic pores in the aluminum surface of the letter. The aluminum letter can also be painted, select from 45 baked enamel colors. An additional two days production time is required for letters with a special finish. The online sign designer is for font style preview only. We provide the approximate sign dimensions for comparison purposes only. We have taken great care in providing the closest sign dimensions possible. Due to manufacturing processes beyond our control (temperature, pressure, mold locations) we cannot guarantee an exact line length. As a rule of thumb, allow 15% margin for space around the letters. This makes your sign more effective as well. Please call for exact dimensions. These characters come with a lifetime warranty against fading, cracking, pitting or chipping as long as the letters are installed in their original location. Routine maintenance of rinsing with mild soap and water usually will restore the metal surface to its original appearance.",
    breadcrumbs: [
      {
        name: "Building Sign Letters",
        href: "https://www.alphabetsigns.com/signs/building-sign-letters.html",
      },
      {
        name: "Cast Metal Letters",
        href: "https://www.alphabetsigns.com/signs/cast-metal-sign-letters.html",
      },
    ],
    defaultSize: "04",
    defaultColor: "Unpainted",
    defaultFillHex: "#A8AAB1",
    sizes: BL20SIZES,
    priceFactor: 1.0,
    scaleFactor: 72,
    pdf: ["cast_metal.pdf"],
    product_attributes: {
      phrase: { type: "text", required: true },
      color: {
        type: "select",
        required: true,
        code: "Baked_Enamel_Colors",
        template_code: "Paint_Color",
        options: [],
      },
      font: { type: "select", required: true, code: "Font", options: [] },
      size: { type: "select", required: true, options: BL20SIZES },
      finish: {
        type: "select",
        required: true,
        code: "Metal_Finish",
        template_code: "",
        options: [],
      },
      hardware: {
        type: "select",
        required: true,
        code: "Hardware",
        template_code: "",
        options: [],
      },
    },
  },
  {
    code: "BL2200",
    name: "Bronze Metal Sign Letters",
    header: "DESIGN YOUR BRONZE METAL LETTERS",
    headerText:
      "Cast metal letters are precision cast in bronze using up to twenty distinct manufacturing steps. Use our sign design tool to view your cast metal letters that provide strength and permanence to your image. Four metal finishes give you the choice of dazzling shine, brilliant color, or natural and antiquated metal. Custom design your cast bronze letters and numbers, preview font styles and calculate sign dimensions.",
    description:
      "Lifetime guarantee! Each metal letter is precision cast in bronze using up to twenty distinct manufacturing steps. The metal provides strength and permanence to your image. Four metal finishes give you the choice of dazzling shine, brilliant color, or natural and antiquated metal. Combine these finishes with an extensive selection of letter styles to design signs that reflect your individual image. The bronze cast sign letters use virgin bronze ingots Alloy NAVY G-88-8-0-4 lead free that are melted down in an all-electric, pollution free furnace. NAVY G-88-8-0-4 lead free is a superior metal for outdoor signage because of its strength and hardness. The melted ingot is poured into a letter mold, which has been designed for excellent legibility. The mold also has added depth to give your character real dimension. Once your letter has been cast by skilled craftsmen, it is shot blasted, degated and belt sanded in preparation of finishing. The cast metal characters are turned over, drilled and tapped at the appropriate stud diameter for its stud mounting hardware used during your installation. In the finishing process, the letter is bead-blasted to make it precise and smooth then stroke sanded to give it a natural satin finish. The letters are set up on a rack where it is coated with a two-part hardened acrylic polyurethane clear coat, then sent to an oven for baking. Your letters are then laid out for careful quality inspection then seal-tight packaged so your letters arrive mistake-free. The cast aluminum letters can be anodizing in the colors of clear, gold, medium bronze, dark bronze or black. The anodized aluminum letter uses virgin ingots Alloy 514. Anodizing is an electro-chemical process which embeds the colored dye into the microscopic pores in the aluminum surface of the letter. The aluminum letter can also be painted, select from 45 baked enamel colors. Bronze metal letters are available in natural satin, oxidized or polished. Polished bronze letters are hand polished and the entire letter face closely conforms to ANSI US9 finish standard. Oxidized bronze letters are treated in a chemical bath, turning them black. The face is then wiped with a stiff sponge to remove some of the black oxidation allowing the yellow bronze to show through. An additional two days production time is required for letters with a special finish. The online sign designer is for font style preview only. We provide the approximate sign dimensions for comparison purposes only. We have taken great care in providing the closest sign dimensions possible. Due to manufacturing processes beyond our control (temperature, pressure, mold locations) we cannot guarantee an exact line length. As a rule of thumb, allow 15% margin for space around the letters. This makes your sign more effective as well. Please call for exact dimensions. These characters come with a lifetime warranty against fading, cracking, pitting or chipping as long as the letters are installed in their original location. Routine maintenance of rinsing with mild soap and water usually will restore the metal surface to its original appearance.",
    breadcrumbs: [
      {
        name: "Building Sign Letters",
        href: "https://www.alphabetsigns.com/signs/building-sign-letters.html",
      },
      {
        name: "Cast Bronze Metal Letters",
        href: "https://www.alphabetsigns.com/signs/bronze-metal-sign-letters.html",
      },
    ],
    defaultSize: "04",
    defaultColor: "Unpainted",
    defaultFillHex: "#B48F6B",
    sizes: BL22SIZES,
    priceFactor: 1.0,
    scaleFactor: 72,
    pdf: ["cast_metal.pdf"],
    product_attributes: {
      phrase: { type: "text", required: true },
      font: { type: "select", required: true, code: "Font", options: [] },
      size: { type: "select", required: true, options: BL22SIZES },
      finish: {
        type: "select",
        required: true,
        code: "Metal_Finish",
        template_code: "",
        options: [],
      },
      hardware: {
        type: "select",
        required: true,
        code: "Hardware",
        template_code: "",
        options: [],
      },
    },
  },
  {
    code: "BL31000",
    name: "Aluminum Sign Letters & Numbers",
    header: "ALUMINUM METAL SIGN LETTERS",
    headerText:
      "Aluminum sign letters are cut out from a flat solid sheet by a waterjet and are available in five thicknesses up to 1 inch and 45 colors. Use our sign design tool to custom design your aluminum sign with letters and numbers, preview font styles and calculate sign dimensions. Custom fonts available at same pricing.",
    description:
      "Flat cut out aluminum letter or number uses aluminum Alloy 5052 that is a superior metal for signage because of its strength, hardness and corrosion resistance against weather extremes particularly in marine areas. The aluminum letters and numbers are custom cut from a flat sheet and is placed on a table where a computer driven waterjet cuts each letter to precision. Once your lettering has been cut, it is prepared for finishing. The cut out aluminum letters and numbers are turned over, and spring pin mounting hardware is attached for use during your installation. In the finishing process, the aluminum cut letters font is bead-blasted to make it precise and smooth then stroke sanded to give it a natural satin finish. The letters are set up on a rack where it is coated with a two-part hardened acrylic polyurethane clear-coat, then sent to an oven for baking. These aluminum letters & numbers come with a lifetime warrantee against fading, cracking, pitting or chipping and is easy to install.",
    breadcrumbs: [
      {
        name: "Building Sign Letters",
        href: "https://www.alphabetsigns.com/signs/building-sign-letters.html",
      },
      {
        name: "Flat Cut Metal Letters",
        href: "https://www.alphabetsigns.com/signs/flat-cut-metal-sign-letters.html",
      },
    ],
    defaultSize: "02",
    defaultColor: "Unpainted",
    defaultFillHex: "#A8AAB1",
    sizes: BL310SIZES,
    priceFactor: 1.0,
    scaleFactor: 72,
    pdf: ["flat_cut_metal.pdf"],
    charset: "ABCDEFGHIJKLMNOPQRSTUVWZYZ 0123456789 &,.-",
    fontAdjustment: 1.05,
    charWidths: CHARWIDTHS,
    product_attributes: {
      phrase: { type: "text", required: true },
      color: {
        type: "select",
        required: true,
        code: "Baked_Enamel_Colors",
        template_code: "Paint_Color",
        options: [],
      },
      font: {
        type: "select",
        required: true,
        code: "Fonts_Vinyl",
        template_code: "Font",
        options: [],
      },
      size: { type: "select", required: true, options: BL310SIZES },
      thickness: {
        type: "select",
        required: true,
        code: "Thickness",
        template_code: "",
        options: [],
      },
      finish: {
        type: "select",
        required: true,
        code: "FCAL_Finishes",
        template_code: "Metal_Finish",
        options: [],
      },
      hardware: {
        type: "select",
        required: true,
        code: "Hardware",
        template_code: "",
        options: [],
      },
    },
  },
  {
    code: "BL32000",
    name: "Bronze Letters & Numbers for Signs",
    header: "BRONZE METAL SIGN LETTERS",
    headerText:
      "Custom bronze letters and numbers are made in a variety of sizes, typestyles and finishes for your custom sign project. Bronze sign letters are cut out from a flat solid metal sheet by a waterjet and are available in three thicknesses six finishes. Use our sign design tool to custom design your bronze sign with letters and numbers, preview font styles and calculate sign dimensions.",
    description:
      "Bronze letters and numbers are made in a variety of sizes, typestyles and finishes for your custom sign project. Bronze metal sign letters are a very durable and versatile material that lasts for decades. The bronze metal letters can be used for indoor conference rooms, in a lobby, or on an office wall. Bronze metal sign letters are also used outdoors for building names, or on signs at entrances to developments and apartments. Bronze letters and numbers are cut out of a flat sheet of bronze Alloy C22000 that is a superior metal for signage because of its strength and hardness. The bronze sign material is mainly copper with tin added to give it its warm look and color. The bronze letters and numbers are custom cut from a flat sheet and are placed on a table where a computer driven waterjet cuts out each letter to precision. The cut out bronze letters and numbers are turned over, and spring pin mounting hardware is attached for use during your installation. In the finishing process, the bronze cut letters font is bead-blasted to make it precise and smooth then stroke sanded to give it a natural satin finish. The bronze sign letters will naturally oxidize over time to provide it with a vintage or antique appearance. The oxidizing can be chemically advanced by an oil rubbed black patina. Natural satin bronze finish and the polished bronze finish are the most popular, especially for home addresses or metal initials. All bronze letters may vary slightly from order to order. The bronze letters are set up on a rack where it is sprayed with a two part, low gloss, hardened acrylic polyurethane clear-coat for protection, and then sent to an oven for baking. These bronze letters and numbers come with a lifetime warrantee against fading, cracking, pitting or chipping and are easy to install.",
    breadcrumbs: [
      {
        name: "Building Sign Letters",
        href: "https://www.alphabetsigns.com/signs/building-sign-letters.html",
      },
      {
        name: "Bronze Metal Letters",
        href: "https://www.alphabetsigns.com/signs/bronze-letters.html",
      },
    ],
    defaultSize: "02",
    defaultColor: "Unpainted",
    defaultFillHex: "#B48F6B",
    sizes: BL320SIZES,
    priceFactor: 1.0,
    scaleFactor: 72,
    pdf: ["flat_cut_metal.pdf"],
    charset: "ABCDEFGHIJKLMNOPQRSTUVWZYZ 0123456789 &,.-",
    fontAdjustment: 1.05,
    charWidths: CHARWIDTHS,
    product_attributes: {
      phrase: { type: "text", required: true },
      font: {
        type: "select",
        required: true,
        code: "Fonts_Vinyl",
        template_code: "Font",
        options: [],
      },
      size: { type: "select", required: true, options: BL320SIZES },
      thickness: {
        type: "select",
        required: true,
        code: "Thickness",
        template_code: "",
        options: [],
      },
      finish: {
        type: "select",
        required: true,
        code: "FCBZ_Finishes",
        template_code: "Metal_Finish",
        options: [],
      },
      hardware: {
        type: "select",
        required: true,
        code: "Hardware",
        template_code: "",
        options: [],
      },
    },
  },
  {
    code: "BL33000",
    name: "Brass Sign Letters & Numbers",
    header: "BRASS METAL SIGN LETTERS",
    headerText:
      "Custom brass letters and numbers are made in a variety of sizes, typestyles and finishes for your custom sign project. Brass sign letters are cut out from a flat solid metal sheet by a waterjet and are available in four thicknesses four finishes. Use our sign design tool to custom design your brass sign with letters and numbers, preview font styles and calculate sign dimensions.",
    description:
      "Brass letters and numbers for signs are custom made in a variety of sizes, typestyles and finishes. The brass lettering cut outs are used for indoor conference rooms, in a hotel or restaurant lobby, or on a decorative office wall. Brass metal sign letters are also used outdoors for building names, company logos, or on signs at entrances to developments and apartments. Brass Alloy C46400 is a superior metal for outdoor signage because of its strength and hardness against weather extremes particularly in marine areas. Brass Alloy C46400 sign material is mainly copper with zinc added to give it its hardness, warm look and color. The brass Alloy C46600 is lead free and is considered navy brass. The manufacturing of brass letters and numbers are custom cut from a flat sheet and is placed on a table where a computer driven waterjet cuts each letter to precision. Once your brass lettering has been waterjet cut, it is prepared for finishing. The cut out brass letters and numbers are turned over, and stud pin mounting hardware is attached that will be used for your installation. During the finishing process, the brass cut letters are held by its studs and is bead-blasted to make each brass letter precise and smooth, then stroke sanded to give it a natural satin finish. The brass letters and numbers, can be polished, antique brass or natural satin brass finish. Brass sign letters will naturally oxidize over time that provides it with a vintage or antique appearance. The oxidizing can be chemically advanced with an oil rubbed black patina. The natural satin brass finish and the polished brass finish are the most popular, especially for home address signs or metal initials. All brass letters may vary slightly from order to order. The brass sign letters are set up on a rack where it is coated with a two-part hardened acrylic polyurethane clear-coat, then sent to an oven for baking. These brass letters and numbers come with a lifetime warrantee against fading, cracking, pitting or chipping and are easy to install.",
    breadcrumbs: [
      {
        name: "Building Sign Letters",
        href: "https://www.alphabetsigns.com/signs/building-sign-letters.html",
      },
      {
        name: "Brass Metal Letters",
        href: "https://www.alphabetsigns.com/signs/brass-letters.html",
      },
    ],
    defaultSize: "02",
    defaultColor: "Unpainted",
    defaultFillHex: "#C5AAD8B",
    sizes: BL330SIZES,
    priceFactor: 1.0,
    scaleFactor: 72,
    pdf: ["flat_cut_metal.pdf"],
    charset: "ABCDEFGHIJKLMNOPQRSTUVWZYZ 0123456789 &,.-",
    fontAdjustment: 1.05,
    charWidths: CHARWIDTHS,
    product_attributes: {
      phrase: { type: "text", required: true },
      font: {
        type: "select",
        required: true,
        code: "Fonts_Vinyl",
        template_code: "Font",
        options: [],
      },
      size: { type: "select", required: true, options: BL330SIZES },
      thickness: {
        type: "select",
        required: true,
        code: "Thickness",
        template_code: "",
        options: [],
      },
      finish: {
        type: "select",
        required: true,
        code: "FCBR_Finishes",
        template_code: "Metal_Finish",
        options: [],
      },
      hardware: {
        type: "select",
        required: true,
        code: "Hardware",
        template_code: "",
        options: [],
      },
    },
  },
  {
    code: "BL40100",
    name: "Acrylic Letters",
    header: "ACRYLIC SIGN LETTERS",
    headerText:
      "Acrylic sign letters are cut out from a flat solid sheet by a laser and are available in four thicknesses up to 1/2 inch and 45 colors. Use our sign design tool to custom design your acrylic sign with letters and numbers, preview font styles and calculate sign dimensions. Custom fonts available at same pricing.",
    description:
      "Acrylic letters for signs are custom cut from a flat sheet and a computer driven laser cuts each acrylic letter to precision. The laser cut out letters have a smooth polished edge. Flat cut out acrylic lettering for signage uses high density polyethylene, which offers better rigidity and tensile strength. The plastic acrylic offers high resistance to chemicals and corrosion, combined with UV inhibitors that help prevent colors from fading. Once the laser cut acrylic lettering has been cut out, mounting hardware is attached for use during your installation. These acrylic letters & numbers come with a lifetime warranty against fading, cracking, pitting or chipping and are easy to install.",
    breadcrumbs: [
      {
        name: "Building Sign Letters",
        href: "https://www.alphabetsigns.com/signs/building-sign-letters.html",
      },
      {
        name: "Acrylic Sign Letters",
        href: "https://www.alphabetsigns.com/signs/flat-cut-acrylic-sign-letters.html",
      },
    ],
    defaultSize: "02",
    defaultColor: "Black_2025",
    defaultFillHex: "#000000",
    sizes: BL401SIZES,
    priceFactor: 1.0,
    scaleFactor: 72,
    pdf: ["flat_cut_acrylic.pdf"],
    charset: "ABCDEFGHIJKLMNOPQRSTUVWZYZ 0123456789 &,.-",
    fontAdjustment: 1.05,
    charWidths: CHARWIDTHS,
    product_attributes: {
      phrase: { type: "text", required: true },
      color: {
        type: "select",
        required: true,
        code: "FCAC_Color",
        template_code: "Color",
        options: [],
      },
      font: {
        type: "select",
        required: true,
        code: "Fonts_Vinyl",
        template_code: "Font",
        options: [],
      },
      size: { type: "select", required: true, options: BL401SIZES },
      hardware: {
        type: "select",
        required: true,
        code: "Mounting_Hardware_Acrylic",
        template_code: "Hardware",
        options: [],
      },
      thickness: {
        type: "select",
        required: true,
        template_code: "Thickness",
        options: [],
      },
    },
  },
  {
    code: "BL40200",
    name: "Metal Laminate on Acrylic Letters",
    header: "METAL FACED ACRYLIC SIGN LETTERS",
    headerText:
      "Metal laminate acrylic letters are perfect when the look and feel of metal is needed but the budget doesn't allow for it. Featuring an upscale look at a fraction of the cost, metal laminated cut out acrylic letters are laser cut and can match any lettering font or custom acrylic logo. The laminate is real metal - a .025 inch layer of metal is bonded to a black acrylic base with a smooth polished edge. Custom fonts available at same pricing.",
    description:
      "Metal laminated acrylic letters are custom cut from a flat sheet and a computer driven laser cuts each acrylic letter to precision. The laminate is real metal - a .025 inch layer of metal is bonded to a black acrylic base with a smooth polished edge. Metal laminated acrylic lettering for signage uses high density polyethylene, which offers better rigidity and tensile strength. The plastic acrylic offers high resistance to chemicals and corrosion, combined with UV inhibitors that help prevent colors from fading. Once the laser cut metal laminated acrylic lettering has been cut out, mounting hardware is attached for use during your installation. These metal laminated acrylic letters & numbers come with a lifetime warranty against fading, cracking, pitting or chipping and are easy to install.",
    breadcrumbs: [
      {
        name: "Building Sign Letters",
        href: "https://www.alphabetsigns.com/signs/building-sign-letters.html",
      },
      {
        name: "Metal Laminate Sign Letters",
        href: "https://www.alphabetsigns.com/signs/metal-laminate-acrylic-sign-letters.html",
      },
    ],
    defaultSize: "03",
    defaultColor: "FCMA_BSA",
    defaultFillHex: "#A8AAB1",
    sizes: BL402SIZES,
    priceFactor: 1.0,
    scaleFactor: 72,
    pdf: ["laminated.pdf"],
    charset: "ABCDEFGHIJKLMNOPQRSTUVWZYZ 0123456789 &,.-",
    fontAdjustment: 1.05,
    charWidths: CHARWIDTHS,
    product_attributes: {
      phrase: { type: "text", required: true },
      font: {
        type: "select",
        required: true,
        code: "Font",
        template_code: "Fonts_Vinyl",
        options: [],
      },
      size: { type: "select", required: true, options: BL402SIZES },
      hardware: {
        type: "select",
        required: true,
        code: "Mounting_Hardware_Acrylic",
        template_code: "Hardware",
        options: [],
      },
      thickness: {
        type: "select",
        required: true,
        template_code: "Thickness",
        options: [],
      },
      color: {
        type: "select",
        required: true,
        code: "FCMA_Finish",
        template_code: "Color",
        options: [],
      },
    },
  },
  {
    code: "ML1000",
    name: "Minnesota Molded Sign Letters",
    header: "MINNESOTA MOLDED SIGN LETTERS",
    headerText:
      "Use our sign design tool to custom design Minnesota letters by Gemini injection molded outdoor plastic letters. They have the look and feel of cast metal letters because of its razor-sharp edges and corners, smooth returns and unblemished letter faces. Minnesota sign letters are available in six font styles, 45 colors and a variety of sizes.",
    description:
      "Minnesota injection molded letters by Gemini are the sign industry's premier plastic letters. Minnesota letters are so popular because you can get the look of cast metal letters but at the low cost and fast turnaround of plastic letters. They have the look and feel of cast metal letters because of its razor-sharp edges and corners, smooth returns and unblemished letter faces. The Minnesota Letters are available in 45 standard colors. Minnesota letters are light weight and easy to install, outdoor rated, these letters are more durable than most plastic letters because of their greater wall thickness and come with a lifetime guarantee. Minnesota letters have incredible detail, a metallic look and appearance, are suitable indoors and outdoors and ships in one business day. Plus, the Minnesota letters are UV stable and made from green non-petroleum based plastic. Mounting hardware is included in the price. Characters come with a lifetime warrantee against chipping, cracking or fading.",
    breadcrumbs: [
      {
        name: "Building Sign Letters",
        href: "https://www.alphabetsigns.com/signs/building-sign-letters.html",
      },
      {
        name: "Minnesota Sign Letters",
        href: "https://www.alphabetsigns.com/signs/minnesota-letters.html",
      },
    ],
    defaultSize: "02",
    defaultColor: "Aztec_Gold_0401",
    defaultFillHex: "#E27023",
    sizes: ML00SIZES,
    priceFactor: 1.0,
    scaleFactor: 72,
    pdf: ["injection_molded_plastic.pdf"],
    product_attributes: {
      phrase: { type: "text", required: true },
      color: {
        type: "select",
        required: true,
        template_code: "Color",
        code: "Baked_Enamel_Swatches",
        options: [],
      },
      font: { type: "select", required: true, code: "Font", options: [] },
      size: { type: "select", required: true, options: ML00SIZES },
      hardware: {
        type: "select",
        required: true,
        code: "Gemini_Minnesota_Hardware",
        template_code: "Hardware",
        options: [],
      },
    },
  },
  {
    code: "PFL100",
    name: "Interior Lobby Wall Letters",
    header: "INTERIOR LOBBY WALL LETTERS",
    headerText:
      "Reception wall lettering is used for office wall signs behind a reception area desk and are great for lobbies, offices, and medical buildings. Use our sign design tool to custom design your dimensional foam letters, preview font styles and calculate sign dimensions.",
    description:
      "This product is best suited for indoor applications like hotel lobbies and professional reception areas. Unlike an outdoor sign letter that can be hard, rounded or shiny, the texture of this dimensional letter is rich, smooth and upscale. These dimensional plastic laminated foam letters are great for lobbies, offices, medical buildings, attorneys, museums, banks, health care facilities, and retail fixtures. These plastic laminated foam sign letters are manufactured from 13lb polystyrene foam sandwiched between two thin surfaces of acrylic veneer, then topped with a acrylic or metal laminate. The exceptionally hard smooth surfaces of the laminate provides durability and rigidity as well as moisture resistance. The letter's face is uniform and blemish free and resists dents and punctures. The high pressure laminated foam letters are available in 30 colors. This is an interior product only as UV rays break down the polystyrene. Letters are cut by a computer driven cutter that produces crisp edges. The sides have sharp 90 degree corners, not rounded over. The high density foam produces high quality, smooth edges, not bubbly or cellulose that looks like a sponge. The sides are a charcoal color. The thicker the letter, the more it will stand off the wall. Letters are easily mounted in six different mounting options. If required, add additional adhesive such as silicone or double sided tape for permanent installation.",
    breadcrumbs: [
      {
        name: "Building Sign Letters",
        href: "https://www.alphabetsigns.com/signs/building-sign-letters.html",
      },
      {
        name: "Reception Wall Letters",
        href: "https://www.alphabetsigns.com/signs/reception-wall-letters.html",
      },
    ],
    defaultSize: "04",
    defaultColor: "FCMA_BSA",
    defaultFillHex: "#A8AAB1",
    sizes: PFL10SIZES,
    priceFactor: 1.0,
    scaleFactor: 72,
    pdf: ["flat_cut_acrylic.pdf"],
    charset: "ABCDEFGHIJKLMNOPQRSTUVWZYZ 0123456789 &,.-",
    fontAdjustment: 1.05,
    charWidths: CHARWIDTHS,
    product_attributes: {
      phrase: { type: "text", required: true },
      color: {
        type: "select",
        required: true,
        template_code: "",
        code: "Color",
        options: [],
      },
      font: {
        type: "select",
        required: true,
        code: "Fonts_Vinyl",
        template_code: "Fonts",
        options: [],
      },
      size: { type: "select", required: true, options: PFL10SIZES },
      hardware: {
        type: "select",
        required: true,
        code: "Hardware",
        template_code: "",
        options: [],
      },
      thickness: {
        type: "select",
        required: true,
        template_code: "",
        code: "Foam_Thickness",
        options: [],
      },
    },
  },
  {
    code: "BL70100",
    name: "PVC Plastic Sign Letter",
    header: "PVC PLASTIC LETTERS",
    headerText:
      "PVC sign letters are cut out from a flat solid sheet by a laser and are available in four thicknesses up to 1/2 inch and 45 colors. Use our sign design tool to custom design your PVC sign with letters and numbers, preview font styles and calculate sign dimensions.",
    description:
      "PVC letters for signs are custom cut from a flat sheet and a computer driven laser cuts each PVC letter to precision. The laser cut out letters have a smooth polished edge. Flat cut out PVC lettering for signage uses high density polyvinylchloride, which offers better rigidity and tensile strength. The plastic PVC offers high resistance to chemicals and corrosion, combined with UV inhibitors that help prevent colors from fading. Once the laser cut PVC lettering has been cut out, mounting hardware is attached for use during your installation. These PVC letters & numbers come with a lifetime warranty against fading, cracking, pitting or chipping and are easy to install.",
    breadcrumbs: [
      {
        name: "Building Sign Letters",
        href: "https://www.alphabetsigns.com/signs/building-sign-letters.html",
      },
      {
        name: "PVC Plastic Sign Letters",
        href: "https://www.alphabetsigns.com/signs/pvc-plastic-sign-letters.html",
      },
    ],
    defaultSize: "04",
    defaultColor: "Aztec_Gold_0401",
    defaultFillHex: "#E27023",
    sizes: BL70SIZES,
    priceFactor: 1.0,
    scaleFactor: 72,
    pdf: ["laminated.pdf"],
    charset: "ABCDEFGHIJKLMNOPQRSTUVWZYZ 0123456789 &,.-",
    fontAdjustment: 1.05,
    charWidths: CHARWIDTHS,
    product_attributes: {
      phrase: { type: "text", required: true },
      color: {
        type: "select",
        required: true,
        template_code: "Color",
        code: "FCAC_Color",
        options: [],
      },
      font: {
        type: "select",
        required: true,
        code: "Fonts_Vinyl",
        template_code: "Font",
        options: [],
      },
      size: { type: "select", required: true, options: BL70SIZES },
      hardware: {
        type: "select",
        required: true,
        code: "Hardware",
        template_code: "Mounting_Hardware_Acrylic",
        options: [],
      },
      thickness: {
        type: "select",
        required: true,
        template_code: "Thickness",
        options: [],
      },
    },
  },
];

export const getProductByCode = (productCode) => {
  return PRODUCTS.find((p) => p.code === productCode) || null;
};
